import axios from 'axios';
import React, { useState, useRef, useReducer, useEffect } from 'react';
import SimpleReactValidator from 'simple-react-validator';
import Footer from '../../layout/Footer';
import Loader from '../common/Loader';
import { createNotification } from '../helpers/Notification';
import { checkValidPasswpord, getApiUrl } from '../helpers/Util';
import { useNavigate, useParams } from 'react-router-dom';


const ResetPassword = () => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [resetKey, setResetKey] = useState("");
  const [loader, setLoader] = useState(false);
  const validator = useRef(new SimpleReactValidator());
  const [, forceUpdate] = useReducer(x => x + 1, 0);
  const navigate = useNavigate();
  const params = useParams();

  // Sync resetKey from params
  useEffect(() => {
    if (params && params.resetKey) {
      setResetKey(params.resetKey);
    }
  }, [params]);

  // Validate token on mount
  useEffect(() => {
    if (params && params.resetKey) {
      validateToken(params.resetKey);
    }
    // eslint-disable-next-line
  }, []);

  const handleOnChange = (event) => {
    if (event.target.name === "password") {
      setPassword(event.target.value);
    } else if (event.target.name === "confirmPassword") {
      setConfirmPassword(event.target.value);
    }
  };

  const handleResetState = () => {
    setPassword("");
    setConfirmPassword("");
    setResetKey("");
  };

  const validateToken = (resetKey) => {
    let result = true;
    const headers = {
      "Content-Type": "application/json",
      "Accept": "application/json"
    };
    const URL = getApiUrl();
    const url = `${URL}/verify-token`;
    const data = { resetKey };
    axios.post(url, data, { headers })
      .then((response) => {
        if (response.status !== 200) {
          result = false;
        }
      })
      .catch((error) => {
        if (error.response && (error.response.status === 422 || error.response.status === 401 || error.response.status === 404)) {
          createNotification("error", "Token Expired!");
          result = false;
          setTimeout(() => { 
            localStorage.clear();
            navigate('/login'); 
          }, 500);
        }
      });
    return result;
  };

  const checkInputData = () => {
    if (confirmPassword === "" || password === "") {
      if (confirmPassword === "")
        createNotification("error", "Confirm password is Required!");
      if (password === "")
        createNotification("error", "Password is Required!");
      return false;
    } else if (confirmPassword !== password) {
      createNotification("info", "Confirm Password and Password do not match!");
      return false;
    } else if (!checkValidPasswpord(confirmPassword)) {
      createNotification("info", "Passwords must be 8 to 15 characters which contain at least one lowercase letter, one uppercase letter, one numeric digit, and one special character!");
      return false;
    }
    return true;
  };

  const handleOnSetPassword = () => {
    if (validator.current.allValid()) {
      if (checkInputData()) {
        const headers = {
          "Content-Type": "application/json",
          "Accept": "application/json"
        };
        setLoader(true);
        const URL = getApiUrl();
        const url = `${URL}/reset-password`;
        const data = { password, confirmPassword, resetKey };
        axios.post(url, data, { headers })
          .then((response) => {
            if (response.status === 200) {
              createNotification("success", "You have successfully changed your password");
              handleResetState();
              setLoader(false);
              setTimeout(() => { 
                localStorage.clear();
                navigate('/login'); 
              }, 1500);
            }
            console.log({ response });
          })
          .catch((error) => {
            createNotification("error", "Invalid Token!");
            setLoader(false);
            console.log({ resetPasswordError: error });
          });
      }
    } else {
      validator.current.showMessages();
      forceUpdate();
    }
  };

  return (
    <div>
      {loader ? <Loader /> :
        <>
          <main className="user-account-page">
            <div className="container-fluid">
              <section className="form-container">
                <div className="row">
                  <div className="col-md-6 logo-col">
                    <div className="logo-content-frame">
                      <h1 className="logo-frame">
                        <span className="logo"></span>
                      </h1>
                      <h2 className="title">Welcome, User</h2>
                      <label className="lbl">Reset Password</label>
                    </div>
                  </div>
                  <div className="col-md-6 form-col">
                    <div className="content-frame">
                      <h2 className="title">Reset Password</h2>
                      <section className="form-frame login-form">
                        <div className="form-group mb-3">
                          <input type="password" name="password" value={password} onChange={handleOnChange} placeholder="New Password" className="form-control" />
                          {validator.current.message('password', password, 'required', { className: 'text-danger' })}
                        </div>
                        <div className="form-group mb-3">
                          <input type="password" name="confirmPassword" value={confirmPassword} onChange={handleOnChange} placeholder="Confirm Password" className="form-control" />
                          {validator.current.message('Confirm Password', confirmPassword, 'required', { className: 'text-danger' })}
                        </div>
                        <div className="btn-row">
                          <input type="button" name="signIn" value="Reset Password" className="btn-rnd-black btn-signIn" onClick={handleOnSetPassword} />
                        </div>
                      </section>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </main>
          <Footer />
        </>
      }
    </div>
  );
};

export default ResetPassword;
